import { Mark, mergeAttributes } from "@tiptap/core";

export const Spoiler = Mark.create({
  name: "spoiler",
  addAttributes() {
    return {
      book: {
        default: "",
        parseHTML: (el) => el.getAttribute("data-book") || "",
        renderHTML: (attrs) => ({ "data-book": attrs.book }),
      },
      bookId: {
        default: "",
        parseHTML: (el) => el.getAttribute("data-book-id") || "",
        renderHTML: (attrs) => (attrs.bookId ? { "data-book-id": attrs.bookId } : {}),
      },
    };
  },
  parseHTML() {
    return [{ tag: "span[data-spoiler]" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(HTMLAttributes, { class: "spoiler", "data-spoiler": "true" }), 0];
  },
});
